import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import {
    StyledConnectedCard,
    StyledHeading,
    StyledHeadingWrapper,
} from './StyledComponents';

const ConnectedModuleCard = ({
    children,
    className,
    ctaComponent,
    isLoading,
    minHeightXL,
    spinnerHeight: height,
    spinnerSize: size,
    title,
    titleGrow,
}) => {
    const renderSpinner = () => (
        <SpinnerContainer size={size} height={height} />
    );

    return (
        <StyledConnectedCard
            className={cx('ConnectedCard', className)}
            minHeightXL={minHeightXL}
        >

            {(title || ctaComponent) && (
                <StyledHeadingWrapper className="ConnectedCard-TitleWrapper">
                    <StyledHeading
                        className="ConnectedCard-Heading"
                        level={3}
                        titleGrow={titleGrow}
                    >
                        {title}
                    </StyledHeading>
                    {ctaComponent && <div className="ConnectedCard-CTA">{ctaComponent}</div>}
                </StyledHeadingWrapper>
            )}

            {isLoading ? renderSpinner() : children}
        </StyledConnectedCard>
    );
};

ConnectedModuleCard.propTypes = {
    ctaComponent: PropTypes.node,
    isLoading: PropTypes.bool,
    minHeightXL: PropTypes.string,
    spinnerHeight: PropTypes.string,
    spinnerSize: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
    title: PropTypes.string,
    titleGrow: PropTypes.number,
};

ConnectedModuleCard.defaultProps = {
    ctaComponent: null,
    isLoading: false,
    minHeightXL: null,
    spinnerHeight: '200px',
    spinnerSize: 'md',
    title: null,
    titleGrow: 1,
};

export default ConnectedModuleCard;
